import { fetcher } from '../fetcher';
export const BASE_PROFILE_URL = 'profile';
const requestConfig = { withCredentials: true };
export async function getLoginMessage(body, signal) {
    const { data } = await fetcher().post(`${BASE_PROFILE_URL}/login-message`, body, { ...requestConfig, signal });
    return data;
}
export async function logIn(body, signal) {
    const { data } = await fetcher().post(`${BASE_PROFILE_URL}/login`, body, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function logOut(signal) {
    const { data } = await fetcher().get(`${BASE_PROFILE_URL}/logout`, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function getProfileSummary(signal) {
    const { data } = await fetcher().get(`${BASE_PROFILE_URL}/summary`, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function getPublicProfileSummary(username, signal) {
    const { data } = await fetcher().get(`${BASE_PROFILE_URL}/public/${username}/summary`, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function getProfileLeaderboard(signal) {
    const { data } = await fetcher().get(`${BASE_PROFILE_URL}/user-leaderboard`, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function getPublicLeaderboard(params, signal) {
    const { data } = await fetcher().get(`${BASE_PROFILE_URL}/public/leaderboard`, {
        ...requestConfig,
        signal,
        params,
    });
    return data;
}
export async function getPublicProfileLeaderboard(username, signal) {
    const { data } = await fetcher().get(`${BASE_PROFILE_URL}/public/${username}/user-leaderboard`, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function getProfileDetails(signal) {
    const { data } = await fetcher().get(`${BASE_PROFILE_URL}/details`, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function updateProfileData(body, signal) {
    const { data } = await fetcher().post(`${BASE_PROFILE_URL}/update`, body, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function getMergeAccountMessage(body, signal) {
    const { data } = await fetcher().post(`${BASE_PROFILE_URL}/merge-request`, body, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function mergeAccount(body, signal) {
    const { data } = await fetcher().post(`${BASE_PROFILE_URL}/merge`, body, {
        ...requestConfig,
        signal,
    });
    return data;
}
export async function getSetClaimMessage(body, signal) {
    const { data } = await fetcher().post(`${BASE_PROFILE_URL}/set-airdrop-wallet-request`, body, { ...requestConfig, signal });
    return data;
}
export async function setClaimWallet(body, signal) {
    const { data } = await fetcher().post(`${BASE_PROFILE_URL}/set-airdrop-wallet`, body, {
        ...requestConfig,
        signal,
    });
    return data;
}
